import type { FormError } from '../types/form';

export const DEFAULT_ERROR: FormError = {
  errors: [],
  errorMessages: {},
  hasError: false,
  isTouched: false,
};
